/* eslint-disable import/prefer-default-export */
export class StylesSwapHelper {
  static swapStyleIfApp = (swapStyle: boolean) => {
    if (swapStyle) {
      const elements = document.getElementsByClassName(
        'o-section--no-padding-top',
      );
      if (elements) {
        // eslint-disable-next-line no-plusplus
        for (let x = 0; x < elements.length; x++) {
          if (elements[x]) {
            elements[x].classList.add('o-section--no-padding-top-app');
            elements[x].classList.remove('o-section--no-padding-top');
          }
        }
      }
    } else {
      const elements = document.getElementsByClassName(
        'o-section--no-padding-top-app',
      );
      if (elements) {
        // eslint-disable-next-line no-plusplus
        for (let x = 0; x < elements.length; x++) {
          elements[x].classList.add('o-section--no-padding-top');
          elements[x].classList.remove('o-section--no-padding-top-app');
        }
      }
    }
  };
}
